<template>
  <div class="flex flex-col gap-2">
    <div v-if="searchable" class="relative">
      <search-icon class="pointer-events-none absolute top-1/2 left-3 z-10 size-4 -translate-y-1/2 text-muted-foreground" />
      <ui-input
        :model-value="searchTerm"
        class="pl-9"
        :placeholder="tr('Search') + '...'"
        :disabled="disabled && loading"
        @update:model-value="(value) => $emit('update:searchTerm', value)"
      />
    </div>

    <button
      v-for="item in items"
      :key="item.key"
      type="button"
      data-slot="asset-select-item"
      :disabled="item.disabled"
      :aria-pressed="item.selected"
      :class="[
        'glass-tile flex w-full items-center gap-3 rounded-xl p-3 text-left',
        GLOW_TRANSITION,
        item.selected ? 'ring-2 ring-primary' : '',
        item.disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer hover:[--tile-glow:color-mix(in_oklab,var(--primary)_40%,transparent)]',
      ]"
      @click="() => $emit('select', item.value)"
    >
      <span
        :class="[
          'flex size-4.5 shrink-0 items-center justify-center rounded-[4px] border',
          item.selected ? 'border-primary bg-primary text-primary-foreground' : 'border-[color:var(--switch-track)]',
        ]"
      >
        <check-icon v-if="item.selected" class="size-3.5" />
      </span>
      <span class="min-w-0 flex-1">
        <slot name="label" :item="item.value" />
      </span>
      <loader-circle-icon v-if="item.loading" class="size-4 shrink-0 animate-spin text-primary" />
      <ui-badge
        v-else-if="item.status"
        :variant="item.selected ? 'default' : (item.statusError ? 'destructive' : 'secondary')"
        class="shrink-0"
      >
        {{ item.status }}
      </ui-badge>
    </button>
  </div>
</template>

<script>
import { Check, LoaderCircle, Search } from '@lucide/vue';

import { GLOW_TRANSITION } from '@/ui/utils/ruleAction.js';

/**
 * Single-choice list of selectable assets (ad accounts, pages) as glass rows.
 * Items: { key, value, selected, disabled, loading, status, statusError }.
 */
export default {
  name: 'AssetSelectList',
  components: {
    CheckIcon: Check,
    LoaderCircleIcon: LoaderCircle,
    SearchIcon: Search,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    searchable: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    searchTerm: {
      type: String,
      required: false,
      default: () => '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  emits: [ 'select', 'update:searchTerm' ],
  data: () => ({
    GLOW_TRANSITION,
  }),
};
</script>
